import { render, staticRenderFns } from "./transaction-blank.vue?vue&type=template&id=f8f0cb62&"
import script from "./transaction-blank.vue?vue&type=script&lang=js&"
export * from "./transaction-blank.vue?vue&type=script&lang=js&"
import style0 from "./transaction-blank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports